// FT API caps pagination: start index ≤ 3000, end index ≤ 3149.
// See https://francetravail.io/data/api/offres-emploi (param `range`).
export const FT_OFFRES_MAX_START = 3000;
export const FT_OFFRES_MAX_END = 3149;
export const FT_OFFRES_MAX_REACHABLE = FT_OFFRES_MAX_END + 1;
